// Default text catalog for the public site.
// Every user-facing string lives here. Admins can override any of them
// from /admin/textes — the override is stored in site_content.ui_texts
// and read at runtime via the useText() hook (TextsContext).
//
// Format: each section is an object describing fields to edit.
// { key: "absolute.key", label: "Champ admin", default: "Texte FR", type: "text"|"textarea" }

export const TEXT_SECTIONS = [
  {
    id: "global",
    title: "Boutons & libellés globaux",
    desc: "Textes utilisés sur plusieurs pages (header, footer, CTA).",
    fields: [
      { key: "nav.cta_reserve", label: "Bouton du header — Réserver", default: "Réserver" },
      { key: "global.cta_contact_short", label: "CTA — Nous contacter", default: "Nous contacter" },
      { key: "global.cta_request", label: "CTA — Faire une demande", default: "Faire une demande" },
      { key: "global.cta_send", label: "Bouton Envoyer", default: "Envoyer" },
      { key: "global.cta_sending", label: "État d'envoi (chargement)", default: "Envoi..." },
      { key: "global.back_home", label: "Retour à l'accueil", default: "Retour à l'accueil" },
      { key: "global.loading", label: "État chargement générique", default: "Chargement..." },
      { key: "footer.address_title", label: "Footer — titre Adresse", default: "Adresse" },
      { key: "footer.links_title", label: "Footer — titre Liens", default: "Liens" },
      { key: "footer.admin_link", label: "Footer — lien gestion", default: "Espace gestion" },
      { key: "footer.copyright_suffix", label: "Footer — suffixe copyright", default: "— immobiliersolaire.fr" },
    ],
  },
  {
    id: "landing",
    title: "Page d'accueil",
    desc: "Hero, stats, blocs « pourquoi nous », CTA final.",
    fields: [
      { key: "landing.stats.0.value", label: "Stat 1 — Valeur (vide = nb auto-calculé)", default: "" },
      { key: "landing.stats.0.label", label: "Stat 1 — Libellé", default: "Bâtiments référencés" },
      { key: "landing.stats.1.value", label: "Stat 2 — Valeur", default: "270–450" },
      { key: "landing.stats.1.label", label: "Stat 2 — Libellé", default: "m² modulables" },
      { key: "landing.stats.2.value", label: "Stat 3 — Valeur", default: "24h" },
      { key: "landing.stats.2.label", label: "Stat 3 — Libellé", default: "Réponse garantie" },
      { key: "landing.stats.3.value", label: "Stat 4 — Valeur", default: "100%" },
      { key: "landing.stats.3.label", label: "Stat 4 — Libellé", default: "Gestion en ligne" },
      { key: "landing.features.kicker", label: "Features — kicker", default: "— Pourquoi nous" },
      { key: "landing.features.title", label: "Features — titre (utilisez \\n pour saut)", default: "Bâti pour les pros.\nPensé pour durer.", type: "textarea" },
      { key: "landing.features.intro", label: "Features — intro", default: "Nos locaux sont conçus pour s'adapter à votre activité : cloisonnement modulable, hauteur sous plafond généreuse, accès poids lourds, raccordements industriels. Vous gérez tout — réservation, paiement d'acompte, demandes — directement en ligne.", type: "textarea" },
      { key: "landing.features.0.title", label: "Feature 1 — Titre", default: "Modulable" },
      { key: "landing.features.0.desc", label: "Feature 1 — Description", default: "Cloisonnement amovible selon vos besoins (270–450 m²)", type: "textarea" },
      { key: "landing.features.1.title", label: "Feature 2 — Titre", default: "Accès PL" },
      { key: "landing.features.1.desc", label: "Feature 2 — Description", default: "Quais de chargement et parking poids lourds inclus", type: "textarea" },
      { key: "landing.features.2.title", label: "Feature 3 — Titre", default: "Triphasé" },
      { key: "landing.features.2.desc", label: "Feature 3 — Description", default: "Électricité 63A, fibre optique, raccordements prêts", type: "textarea" },
      { key: "landing.features.3.title", label: "Feature 4 — Titre", default: "Sécurisé" },
      { key: "landing.features.3.desc", label: "Feature 4 — Description", default: "Site clôturé, vidéosurveillance 24/7", type: "textarea" },
      { key: "landing.properties.kicker", label: "Locaux — kicker", default: "— Nos locaux disponibles" },
      { key: "landing.properties.title", label: "Locaux — titre", default: "Choisissez votre espace." },
      { key: "landing.properties.see_all", label: "Locaux — Voir tout", default: "Voir tout" },
      { key: "landing.cta.title_line1", label: "CTA — ligne 1", default: "Besoin d'un local" },
      { key: "landing.cta.title_line2", label: "CTA — ligne 2 (accentuée)", default: "sur mesure ?" },
      { key: "landing.cta.desc", label: "CTA — description", default: "Configurations spécifiques, surfaces particulières, équipements dédiés. Décrivez-nous votre projet, on revient vers vous sous 24h.", type: "textarea" },
    ],
  },
  {
    id: "listings",
    title: "Page Nos locaux",
    desc: "Liste des bâtiments + filtres.",
    fields: [
      { key: "listings.kicker", label: "Kicker", default: "— Catalogue" },
      { key: "listings.title", label: "Titre", default: "Nos locaux d'activité" },
      { key: "listings.subtitle", label: "Sous-titre", default: "Bâtiments industriels modulables de 270 à 450 m² situés à Cerquottes (45520), au bord de la Nationale 20.", type: "textarea" },
      { key: "listings.filter_label", label: "Label filtre surface", default: "Surface minimum" },
      { key: "listings.filter_date_label", label: "Label filtre date dispo", default: "Disponible avant le" },
      { key: "listings.filter_reset", label: "Bouton — Réinitialiser filtres", default: "Réinitialiser" },
      { key: "listings.filter_all", label: "Filtre — Toutes", default: "Toutes" },
      { key: "listings.empty", label: "Message liste vide", default: "Aucun local disponible avec ces critères." },
    ],
  },
  {
    id: "about",
    title: "Page À propos",
    fields: [
      { key: "about.cta.title", label: "Bandeau CTA — Titre", default: "Discutons de votre projet." },
      { key: "about.cta.desc", label: "Bandeau CTA — Description", default: "Visite, demande personnalisée ou information générale — nous répondons sous 24h ouvrées.", type: "textarea" },
    ],
  },
  {
    id: "contact",
    title: "Page Contact",
    fields: [
      { key: "contact.kicker", label: "Kicker", default: "— Contact" },
      { key: "contact.title", label: "Titre", default: "Nous rencontrer." },
      { key: "contact.subtitle", label: "Sous-titre", default: "À Cercottes, sur la Nationale 20. Posez-nous votre question, on répond sous 24h.", type: "textarea" },
      { key: "contact.coords_title", label: "Bloc — Coordonnées", default: "Coordonnées" },
      { key: "contact.addr_label", label: "Label — Adresse", default: "Adresse" },
      { key: "contact.city_prefix", label: "Préfixe ville", default: "Ville :" },
      { key: "contact.phone_label", label: "Label — Téléphone", default: "Téléphone" },
      { key: "contact.email_label", label: "Label — Email", default: "Email" },
      { key: "contact.hours_label", label: "Label — Horaires", default: "Horaires" },
      { key: "contact.form_title", label: "Titre du formulaire", default: "Envoyer un message" },
      { key: "contact.form.name_ph", label: "Placeholder — Nom complet", default: "Nom complet *" },
      { key: "contact.form.email_ph", label: "Placeholder — Email", default: "Email *" },
      { key: "contact.form.phone_ph", label: "Placeholder — Téléphone", default: "Téléphone *" },
      { key: "contact.form.company_ph", label: "Placeholder — Société", default: "Société" },
      { key: "contact.form.message_ph", label: "Placeholder — Message", default: "Votre message *" },
      { key: "contact.success", label: "Message succès envoi", default: "Message envoyé — nous vous recontactons sous 24h." },
      { key: "contact.access.title", label: "Bandeau accès — Titre", default: "Sur la Nationale 20." },
      { key: "contact.access.desc", label: "Bandeau accès — Description", default: "À 15 km au nord d'Orléans, accès direct A10 / A19 / A77. Idéal pour distribution sur tout le bassin parisien et centre Loire.", type: "textarea" },
    ],
  },
  {
    id: "custom",
    title: "Page Demande sur mesure",
    fields: [
      { key: "custom.kicker", label: "Kicker", default: "— Demande personnalisée" },
      { key: "custom.title", label: "Titre", default: "Décrivez votre projet." },
      { key: "custom.subtitle", label: "Sous-titre", default: "Surface inhabituelle, équipement particulier, configuration spécifique — on étudie votre demande et on revient vers vous sous 24h ouvrées.", type: "textarea" },
      { key: "custom.f.name", label: "Champ — Nom complet", default: "Nom complet *" },
      { key: "custom.f.email", label: "Champ — Email", default: "Email *" },
      { key: "custom.f.phone", label: "Champ — Téléphone", default: "Téléphone *" },
      { key: "custom.f.company", label: "Champ — Société", default: "Société" },
      { key: "custom.f.surface", label: "Champ — Surface", default: "Surface recherchée" },
      { key: "custom.f.surface_ph", label: "Placeholder — Surface", default: "ex: 300-400 m²" },
      { key: "custom.f.activity", label: "Champ — Activité", default: "Type d'activité" },
      { key: "custom.f.activity_ph", label: "Placeholder — Activité", default: "ex: logistique, atelier..." },
      { key: "custom.f.message", label: "Champ — Description", default: "Description du besoin *" },
      { key: "custom.f.message_ph", label: "Placeholder — Description", default: "Quais de chargement, hauteur, raccordements, dates, durée..." },
      { key: "custom.submit", label: "Bouton — Envoyer", default: "Envoyer la demande" },
      { key: "custom.success", label: "Message succès", default: "Demande envoyée. Réponse sous 24h." },
    ],
  },
  {
    id: "reservation",
    title: "Page Réservation",
    fields: [
      { key: "reservation.title", label: "Titre", default: "Réserver ce local" },
      { key: "reservation.subtitle", label: "Sous-titre", default: "Choisissez votre type de demande, puis remplissez le formulaire.", type: "textarea" },
      { key: "reservation.type.contact.label", label: "Type — Contact (titre)", default: "Prise de contact" },
      { key: "reservation.type.contact.desc", label: "Type — Contact (desc)", default: "On vous rappelle pour discuter du projet" },
      { key: "reservation.type.visit.label", label: "Type — Visite (titre)", default: "Demande de visite" },
      { key: "reservation.type.visit.desc", label: "Type — Visite (desc)", default: "Planifions ensemble une visite sur site" },
      { key: "reservation.type.paid.label", label: "Type — Acompte (titre)", default: "Réservation avec acompte" },
      { key: "reservation.type.paid.desc", label: "Type — Acompte (desc)", default: "Bloquer ce local — acompte 500€ remboursable" },
      { key: "reservation.deposit_note", label: "Note acompte", default: "Acompte de réservation : 500 € HT (paiement sécurisé Stripe). Ce montant est déduit de votre premier loyer si la location est confirmée, remboursé sinon sous 14 jours.", type: "textarea" },
      { key: "reservation.submit_paid", label: "Bouton — Payer", default: "Payer l'acompte et réserver" },
      { key: "reservation.submit_other", label: "Bouton — Envoyer demande", default: "Envoyer la demande" },
      { key: "reservation.success", label: "Message succès", default: "Demande envoyée. Nous vous recontactons sous 24h." },
    ],
  },
  {
    id: "payment",
    title: "Page Paiement",
    fields: [
      { key: "payment.kicker", label: "Kicker", default: "— Paiement confirmé" },
      { key: "payment.success.title", label: "Succès — Titre", default: "Votre acompte est reçu." },
      { key: "payment.success.desc", label: "Succès — Description", default: "Votre réservation est confirmée. Nous vous recontactons sous 24h ouvrées pour finaliser le bail.", type: "textarea" },
      { key: "payment.expired.title", label: "Expiré — Titre", default: "Session expirée" },
      { key: "payment.expired.desc", label: "Expiré — Description", default: "Le paiement n'a pas pu être finalisé. Vous pouvez réessayer.", type: "textarea" },
      { key: "payment.pending.title", label: "Vérification — Titre", default: "Vérification du paiement..." },
    ],
  },
  {
    id: "blog",
    title: "Page Blog",
    fields: [
      { key: "blog.kicker", label: "Kicker", default: "— Le blog" },
      { key: "blog.title", label: "Titre", default: "Actualités & expertises" },
      { key: "blog.subtitle", label: "Sous-titre", default: "Conseils, études de cas et expertise sur l'immobilier d'activité et le photovoltaïque.", type: "textarea" },
      { key: "blog.search_ph", label: "Placeholder recherche", default: "Rechercher un article..." },
      { key: "blog.cat_all", label: "Filtre — Toutes catégories", default: "Toutes" },
      { key: "blog.empty", label: "Message liste vide", default: "Aucun article ne correspond à votre recherche." },
      { key: "blog.read_more", label: "Lien — Lire l'article", default: "Lire l'article" },
      { key: "blog.related_title", label: "Titre — Articles liés", default: "À lire également" },
      { key: "blog.toc_title", label: "Titre — Sommaire", default: "Sommaire" },
    ],
  },
];

export const ALL_DEFAULTS = TEXT_SECTIONS.reduce((acc, s) => {
  s.fields.forEach(f => { acc[f.key] = f.default; });
  return acc;
}, {});
